import { Fragment } from 'react';
import HeaderBotton from '../../../components/HeaderBottom';
import HeaderTop from '../../../components/HeaderTop';
import Breadcumb from '../../../components/Breadcumb';
import FooterArea from '../../../components/FooterArea';
import Form from '../../../components/Form';
// images
import breadcumb from '../../../images/breadcumb/contact-us-old-classic-phone.jpg';

import './style.scss';

const breadcumbMenu = [{ name: 'Home', route: '/' }, { name: 'Contact' }];

const ContactPage = () => {
  return (
    <Fragment>
      <header className='headerArea'>
        <HeaderTop className='headerTop' />
        <HeaderBotton className='headerBottomArea headerBottomAreaStyelTwo' />
      </header>
      <Breadcumb
        className='breadcumbArea'
        title='Contact'
        breadcumbMenu={breadcumbMenu}
        background={breadcumb}
      />

      <div className='contactusPageArea'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-5'>
              <div className='contactUsInfo'>
                <h3>Contact Information</h3>
                <p>
                  You may contact us via email using our contact form, or call
                  us at anytime. Outside of business hours, leave a message and
                  we'll get back to you as soon as possible.
                </p>
                <h4>Address</h4>
                <span>
                  2620 Mary Hill Road,
                  <br /> Port Coquitlam, BC
                </span>
                <hr />
                <span>
                  Phone: <a href='tel:1.604.927.2156'>604.927.2156</a>
                </span>
                <span>Fax: 604.927.2155</span>
                <span>Email: adam@fritzlerlaw.ca</span>
              </div>
            </div>
            <div className='col-lg-7'>
              <div className='contactUSForm'>
                <h3>Send us a Message</h3>
                <Form addressInfo={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterArea />
    </Fragment>
  );
};
export default ContactPage;
